import { render, staticRenderFns } from "./ChatInputComponent.vue?vue&type=template&id=502d1fdf&scoped=true&"
import script from "./ChatInputComponent.vue?vue&type=script&lang=ts&"
export * from "./ChatInputComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChatInputComponent.vue?vue&type=style&index=0&id=502d1fdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502d1fdf",
  null
  
)

export default component.exports